import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { CustomizationsQuestionsService } from './customizations-questions.service';
import { CustomizationsListComponent } from './customizations-list/customizations-list.component';
import { CustomizationsComponent } from './customizations/customizations.component';
import { CustomizationsRoutingModule } from './customizations-routing.module';
import { CustomizationEditorComponent } from './customization-editor/customization-editor.component';
import { CustomizationDetailComponent } from './customization-detail/customization-detail.component';
import { CustomizationsListRowComponent } from './customizations-list/customizations-list-row/customizations-list-row.component';
import { CustomizationsListDetailComponent } from './customizations-list/customizations-list-detail/customizations-list-detail.component';
import { CustomizationCreateComponent } from './customization-create/customization-create.component';
import { CustomizationVisualizerPopupComponent } from './customization-visualizer-popup/customization-visualizer-popup.component';
import { DocumentsModule } from 'app/documents/documents.module';

@NgModule({
  imports: [CommonModule, CoreModule, CustomizationsRoutingModule, DocumentsModule],
  declarations: [
    CustomizationsListComponent,
    CustomizationsComponent,
    CustomizationEditorComponent,
    CustomizationDetailComponent,
    CustomizationsListRowComponent,
    CustomizationsListDetailComponent,
    CustomizationVisualizerPopupComponent,
    CustomizationCreateComponent
  ],
  exports: [CustomizationsListComponent],
  providers: [CustomizationsQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomizationsModule {}
